import React from 'react';
import styled from '@emotion/styled';

import theme from '../../theme';
import { MAX_WIDTH_FORM_COMPONENT, MAX_MOBILE_WIDTH_FORM_COMPONENT } from '../../utils/form';

const Container = styled.div`
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: ${MAX_WIDTH_FORM_COMPONENT}px;
  @media (max-width: ${theme.screenLgMax}) {
    max-width: ${MAX_MOBILE_WIDTH_FORM_COMPONENT}px;
  }
`;

const Title = styled.h2`
  color: ${theme.colorsBlack};
  font-weight: bold;
`;

export interface Props {
  title?: string;
}

const DocumentTypeMetadataTitle = React.memo(function DocumentTypeMetadataTitle({ title, ...props }: Props) {
  return (
    <Container>
      <Title {...props}>{title}</Title>
    </Container>
  );
});

export default DocumentTypeMetadataTitle;
